export default {
    CLOSE_ALL_POPUP: '[SESSION] CLOSE_ALL_POPUP',
    POPUP_OPEN_SESSION: '[SESSION] POPUP_OPEN_SESSION',
    POPUP_OPEN_SESSION_CASH_CONTROL: '[SESSION] POPUP_OPEN_SESSION_CASH_CONTROL',
    POPUP_ACTIVITIES_HISTORY: '[SESSION] POPUP_ACTIVITIES_HISTORY',
    POPUP_PUT_MONEY_IN: '[SESSION] POPUP_PUT_MONEY_IN',
    POPUP_TAKE_MONEY_OUT: '[SESSION] POPUP_TAKE_MONEY_OUT',
    POPUP_CLOSE_SESSION: '[SESSION] POPUP_CLOSE_SESSION',
    POPUP_CLOSE_SESSION_CASH_CONTROL: '[SESSION] POPUP_CLOSE_SESSION_CASH_CONTROL',
    POPUP_VALIDATE_SESSION: '[SESSION] POPUP_VALIDATE_SESSION',

    GET_CURRENT_SESSION: '[SESSION] GET_CURRENT_SESSION',
    TYPE_GET_CURRENT_SESSION: 'get_current_session',

    SET_CURRENT_SESSION: '[SESSION] SET_CURRENT_SESSION',

    GET_LIST_SESSION: '[SESSION] GET_LIST_SESSION',
    GET_LIST_SESSION_RESULT: '[SESSION] GET_LIST_SESSION_RESULT',

    SYNC_ACTION_UPDATE_DATA_FINISH: '[SESSION] SYNC_ACTION_UPDATE_DATA_FINISH',
    SYNC_DELETED_SESSION_FINISH: '[SESSION] SYNC_DELETED_SESSION_FINISH',

    REDIRECT_TO_MANAGE_SESSION: '[SESSION] REDIRECT_TO_MANAGE_SESSION',
    REDIRECT_TO_MANAGE_SESSION_SUCCESS: '[SESSION] REDIRECT_TO_MANAGE_SESSION_SUCCESS',

    REQUEST_OPEN_SESSION: '[SESSION] REQUEST_OPEN_SESSION',
    REQUEST_PUT_MONEY_IN: '[SESSION] REQUEST_PUT_MONEY_IN',
    REQUEST_TAKE_MONEY_OUT: '[SESSION] REQUEST_TAKE_MONEY_OUT',
    REQUEST_SET_CLOSE_SESSION: '[SESSION] REQUEST_SET_CLOSE_SESSION',
    REQUEST_CLOSE_SESSION: '[SESSION] REQUEST_CLOSE_SESSION',


    PRINT_REPORT: '[SESSION] PRINT_REPORT',

    SESSION_SINCE_24H: '24h',
    SESSION_SINCE_7_DAYS: '7days',
    SESSION_SINCE_MONTH: 'month',
    SESSION_SINCE_YTD: 'YTD',
    SESSION_SINCE_2_YTD: '2YTD',

    PAGE_SIZE: 10,

    // Session status
    SESSION_OPEN: 0,
    SESSION_CLOSE: 1,

    // Cash Transaction Type
    CASH_TRANSACTION_ADD: 'add',
    CASH_TRANSACTION_REMOVE: 'remove',
    CASH_TRANSACTION_CHANGE: 'change',

    // Config Path
    XML_PATH_CONFIG_SYNC_SESSION_TIME: "webpos/offline/session_time",
    XML_PATH_CONFIG_SYNC_SESSION_SINCE: "webpos/session/session_since",
}



// WEBPACK FOOTER //
// ./src/view/constant/SessionConstant.js